import React from "react";
import { useSelector, useDispatch } from "react-redux";
import RoomIcon from "@mui/icons-material/Room";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import "./MarkerPopup.css";

import {
  setSidebarVisibility,
  fetchSelectedVillageDetailsSuccess,
} from "../../redux/reducers/selectedVillageDetails";
import { setStatusDropdownVisibility } from "../../redux/reducers/siteStatus";

import DottedCircleLoader from "../Loader/DottedCircleLoader";
import Translate from "../Translate/Translate";

import pmayLogo from "../../assets/images/pmay-logo.png";

const MarkerPopup = ({ popupCoordinates, siteImage, setShowPopup }) => {
  const selectedMarker = useSelector(
    (state) => state.verticalSidebar.selectedSites
  );
  const siteStatus = useSelector((state) => state.siteStatus);

  const dispatch = useDispatch();

  const handleCheckboxChange = () => {
    const currSiteId = popupCoordinates.ID;
    console.log("handleCheckboxChange ", popupCoordinates.Zone);
    // const currentCheckboxChange = {};
    // currentCheckboxChange[currSiteId] = true;

    // if (selectedMarker[popupCoordinates.ID]) {
    //   currentCheckboxChange[currSiteId] = false;
    // }

    //dispatch(setSelectedMarkers(currSiteId));
    // dispatch(fetchSelectedMarkerSuccess(currentCheckboxChange));
    // dispatch(setSidebarType("pathTraversal"));
  };

  const handleSidebarTypeChange = (siteInfo, statusDropdownVisibility) => {
    // dispatch(setSidebarVisibility(true));

    // if (setStatusDropdownVisibility !== null) {
    //   dispatch(setStatusDropdownVisibility(statusDropdownVisibility));
    // }

    // dispatch(
    //   setSidebarType({
    //     sidebarType: siteInfo.status !== "new" ? "siteProgress" : "siteInfo",
    //     siteInfo: siteInfo,
    //   })
    // );
    dispatch(fetchSelectedVillageDetailsSuccess(siteInfo));
    dispatch(setSidebarVisibility(true));
    console.log("type of site is ", typeof siteInfo, siteInfo);
    console.log("show selected site info****************");
  };

  return (
    <div className="marker-popup-container">
      <div className="select-path-traversal-container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "10px",
          }}
        >
          <div
            className="marker-popup-top-show-more"
            //onClick={() => handleSidebarTypeChange(popupCoordinates, false)}
          >
            #{popupCoordinates.id}
          </div>

          <div onClick={() => {}}>
            <a
              href={
                popupCoordinates.site_location || popupCoordinates.land_location
              }
              target="_blank"
            >
              <RoomIcon
                className="cursor-pointer"
                fontSize="small"
                style={{ color: "black" }}
              />
            </a>
          </div>

          <div onClick={() => {}}>
            <a
              href={
                popupCoordinates.site_streetview ||
                popupCoordinates.land_streetview
              }
              target="_blank"
            >
              <PersonPinCircleIcon
                className="cursor-pointer"
                fontSize="small"
                style={{ color: "black" }}
              />
            </a>
          </div>
        </div>

        <div
          style={{
            color: "var(--text-color)",
          }}
          onClick={() => {
            setShowPopup(false);
          }}
        >
          <CancelIcon
            className="cursor-pointer"
            fontSize="small"
            style={{ color: "var(--text-color)" }}
          />
        </div>
      </div>

      <div className="marker-popup-middle-container">
        <div className="popup-image-container">
          {siteImage !== null ? (
            <>
              <div className="popup-image-sub-container">
                <img
                  src={"data:image/png;base64, " + siteImage}
                  className="popup-image popup-image-1"
                  style={{
                    height: "25rem",
                    width: "26rem",
                  }}
                />
              </div>

              <div className="date-container">
                <p>Old</p>
                <p id="image-2-date">New</p>
              </div>
            </>
          ) : (
            <DottedCircleLoader />
          )}
        </div>
      </div>

      <div className="site-info-details">
        {popupCoordinates.site_size && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"SITE SIZE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={popupCoordinates.site_size ? `${popupCoordinates.site_size} m²` : "No site size available"}
              />
            </span>
          </div>
        )}

        {popupCoordinates.site_address && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"SITE ADDRESS"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.site_address || "No site_Address Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.site_latitude && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"SITE LATITUDE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.site_latitude || "No site_latitude Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.site_longitude && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"SITE LONGITUDE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.site_longitude ||
                  "No site_longitude Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.site_land_usage && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"SITE LAND USAGE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.site_land_usage ||
                  "No site_land_usage Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.land_size && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"LAND_PARCEL SIZE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.land_size || "No LAND_PARCEL SIZE Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.land_address && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"LAND_PARCEL ADDRESS"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.land_address ||
                  "No LAND_PARCEL Address Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.land_latitude && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"LAND_PARCEL LATITUDE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.land_latitude ||
                  "No LAND_PARCEL latitude Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.land_longitude && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"LAND_PARCEL LONGITUDE"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.land_longitude ||
                  "No LAND_PARCEL longitude Available"
                }
              />
            </span>
          </div>
        )}

        {popupCoordinates.gov_status && (
          <div className="site-info-pair">
            <strong>
              <Translate text={"GOVERNMENT STATUS"} />
            </strong>{" "}
            :
            <span>
              <Translate
                text={
                  popupCoordinates.gov_status || "No site gov_status Available"
                }
              />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarkerPopup;
